@if (available()) {
  <button
    mat-icon-button
    type="button"
    class="global-assistant__trigger"
    [class.global-assistant__trigger--active]="assistant.isOpen()"
    [class.global-assistant__trigger--busy]="assistant.busy()"
    [matTooltip]="'$ai.global.title' | translateAsync"
    [attr.aria-label]="'$ai.global.title' | translateAsync"
    [attr.aria-expanded]="assistant.isOpen()"
    (click)="assistant.toggle()"
  >
    <mat-icon fontSet="hgi" fontIcon="hgi-ai-magic"></mat-icon>
    @if (!assistant.isOpen() && assistant.unread()) {
      <span class="global-assistant__marker" [attr.aria-label]="'$ai.global.unread' | translateAsync"></span>
    }
  </button>

  @if (!assistant.isOpen() && assistant.bubble(); as text) {
    <div class="global-assistant__bubble" role="status" (click)="assistant.open()">
      <span class="global-assistant__bubble-text">{{ text }}</span>
      <button
        type="button"
        class="global-assistant__bubble-dismiss"
        [attr.aria-label]="'$ai.global.close' | translateAsync"
        (click)="dismissBubble($event)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  @if (mounted()) {
    <section
      class="global-assistant__panel"
      [class.global-assistant__panel--hidden]="!assistant.isOpen()"
      role="dialog"
      [attr.aria-hidden]="!assistant.isOpen()"
      [attr.aria-label]="'$ai.global.title' | translateAsync"
    >
      <wbi-ai-chat></wbi-ai-chat>
    </section>
  }
}
